import React from "react";
import Sidebar from "./Sidebar";
import { graphql, compose, withApollo } from "react-apollo";
import gql from "graphql-tag";
import QuickRdvTaker from "./QuickRdvTaker";
import ContentLoader from "react-content-loader";
import ChatModal from "./ChatModal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MessageNotification from "./MessageNotification";
import sound from "../../sound/notif.mp3";
import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";


class Layout extends React.Component {
  toastId = null;

  constructor(props) {
    super(props);
    this.state = {
      patientId: null,

      isOpenChatModal: false,
      isHistoryModalOpen:
        props.getIsHistoryModalOpen.patientHistoryModal.isOpenHistoryModal,
      idPatientToShow:
        props.getIsHistoryModalOpen.patientHistoryModal.idPatientToShow,
    };
  }
  isLoggedIn = () => {
    return (
      this.props.loggedInUserQuery.loggedInUser &&
      this.props.loggedInUserQuery.loggedInUser.id !== null
    );
  };

  componentWillMount() {
    /*  if (this.state.isOpenDeleteModal) {
      document.documentElement.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "auto";
    }*/
  }

  componentWillReceiveProps(newProps) {
    if (newProps.getIsHistoryModalOpen.patientHistoryModal) {
      this.setState({
        isHistoryModalOpen:
          newProps.getIsHistoryModalOpen.patientHistoryModal.isOpenHistoryModal,
        idPatientToShow:
          newProps.getIsHistoryModalOpen.patientHistoryModal.idPatientToShow,
      });
    }

    if (
      this.props.loggedInUserQuery.loading &&
      !newProps.loggedInUserQuery.loading
    ) {
      const doctorId = newProps.loggedInUserQuery.loggedInUser.id;
      const userEmail = newProps.loggedInUserQuery.loggedInUser.email;
      this.props.client
        .query({
          query: NEW_MESSAGES,
          variables: { doctorId },
        })
        .then((res) => {
          if (res !== null && res.data !== null) {
            res.data.allMessages.forEach((message) => {
              toast(
                <MessageNotification
                  message={message}
                  userId={doctorId}
                  email={userEmail}
                  openHistoryModal={this.openHistoryModal}
                  closeHistoryModal={this.closeHistoryModal}
                />,
                {
                  progressClassName: "toast-progessbar",
                  style: { top: "4em", height: "160px", zIndex: 100 },
                  className: "message-toast",
                  bodyClassName: "message-notification-body",
                  position: "top-right",
                  autoClose: false,
                  newestOnTop: false,
                  closeButton: false,
                  closeOnClick: false,
                  rtl: false,
                  draggablePercent: 80,
                  pauseOnVisibilityChange: false,
                  draggable: false,
                  onOpen: () => {
                    this.audioEnter.play();
                  },
                }
              );
            });
          }
        });

      //    node: { doctor: { id: $doctorId } }
      newProps.newMessagesQuery.subscribeToMore({
        document: gql`
          subscription messagesSub($doctorId: ID!) {
            Message(
              filter: {
                mutation_in: [CREATED, UPDATED]
                node: { to_some: { id: $doctorId } }
              }
            ) {
              mutation
              previousValues {
                id
              }
              updatedFields
              node {
                id
                createdAt
                text
                patient {
                  id
                  nom
                  prenom
                  matricule
                }
                to {
                  id
                  name
                }
                from {
                  id
                  name
                }
                reply {
                  id
                  from {
                    id
                    name
                  }
                  patient {
                    id
                    nom
                    prenom
                  }
                  text
                  createdAt
                }
              }
            }
          }
        `,
        variables: { doctorId },

        updateQuery: (previousState, { subscriptionData }) => {
          const TYPE = subscriptionData.data.Message.mutation;
          if (TYPE === "CREATED") {
            const message = subscriptionData.data.Message.node;
            toast(
              <MessageNotification
                message={message}
                userId={doctorId}
                email={userEmail}
                openHistoryModal={this.openHistoryModal}
                closeHistoryModal={this.closeHistoryModal}
              />,
              {
                progressClassName: "toast-progessbar",
                style: { top: "4em", height: "160px", zIndex: 100 },
                className: "message-toast",
                bodyClassName: "message-notification-body",
                position: "top-right",
                autoClose: false,
                newestOnTop: false,
                closeButton: false,
                closeOnClick: false,
                rtl: false,
                draggablePercent: 80,
                pauseOnVisibilityChange: false,
                draggable: false,
                onOpen: () => {
                  this.audioEnter.play();
                },
              }
            );
          }
          if (TYPE === "UPDATED") {
            const message = subscriptionData.data.Message.node;
            if (message.status === "REPLIED") {
              toast(
                <MessageNotification
                  message={message}
                  userId={doctorId}
                  email={userEmail}
                  openHistoryModal={this.openHistoryModal}
                  closeHistoryModal={this.closeHistoryModal}
                />,
                {
                  progressClassName: "toast-progessbar",
                  style: { top: "4em", height: "160px", zIndex: 100 },
                  className: "message-toast",
                  bodyClassName: "message-notification-body",
                  position: "top-right",
                  autoClose: false,
                  newestOnTop: false,
                  closeButton: false,
                  closeOnClick: false,
                  rtl: false,
                  draggablePercent: 80,
                  pauseOnVisibilityChange: false,
                  draggable: false,
                  onOpen: () => {
                    this.audioEnter.play();
                  },
                }
              );
            }
          }
        },
        onError: (err) => {
          console.error(err);
        },
      });
    }
  }

  componentWillUnmount() {
    /*  if (this.state.isOpenDeleteModal) {
      document.documentElement.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "auto";
    }*/
  }

  /*toggleConfirm = () => {
    /*  let idPatientToDelete = null;
    let isOpenDeleteModal = false;
    this.props.updateDeleteModal({
      variables: {
        isOpenDeleteModal,
        idPatientToDelete
      }
    });
  };*/

  openHistoryModal = (idPatientToShow) => {
    let isOpenHistoryModal = true;
    this.props.updateHistoryModal({
      variables: {
        isOpenHistoryModal,
        idPatientToShow,
      },
    });
  };

  closeHistoryModal = () => {
    this.props.updateHistoryModal({
      variables: {
        isOpenHistoryModal: false,
        idPatientToShow: null,
      },
    });
  };

  toggleChatModal = (patientId = null) => {
    this.setState({ isOpenChatModal: !this.state.isOpenChatModal, patientId });
  };

  /*handlePatientDelete = () => {
    let id = this.state.idPatientToDelete;
    this.props
      .deletePatient({
        variables: {
          id
        }
      })
      .then(() => {
        this.toggleConfirm();
      });
  };*/
  render() {
    if (
      this.props.loggedInUserQuery
        .loading /*||
      this.props.allSlotsQuery.loading*/
    ) {
      return (
        <section className="hero is-fullheight is-vcentered">
          <div className="hero-body">
            <div className="container">
              <div className="columns  is-centered">
                <div className="column is-4 has-text-centered">
                  <ContentLoader type="facebook" />
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    }

    if (!this.isLoggedIn()) {
      this.props.history.replace("/login");
    }
    if (this.props.loggedInUserQuery.loggedInUser.role === "ADMIN") {
      this.props.history.replace("/admin");
      return null;
    }
    const userId = this.props.loggedInUserQuery.loggedInUser.id;
    const role = this.props.loggedInUserQuery.loggedInUser.role;
    const name = this.props.loggedInUserQuery.loggedInUser.name;
    //    const options = { daysAhead: 60, baseDuration: 15 }; //this.props.loggedInUserQuery.loggedInUser.options;
    const { children } = this.props;

    var childrenWithProps = React.Children.map(children, (child) =>
      React.cloneElement(child, {
        //    slots: this.props.allSlotsQuery.allSlots,
        role: role,
        userName: name,
        doctorId: userId,
        toggleChatModal: this.toggleChatModal,
        //    options: options
      })
    );
    return (
      <div className="has-navbar-fixed-top">
        <audio ref={(r) => (this.audioEnter = r)}>
          <source src={sound} type="audio/mpeg" />
        </audio>

        <Sidebar role={role} name={name} />
        <QuickRdvTaker
          doctorId={userId}
          role={role}
          history={this.props.history}
          toggleChatModal={this.toggleChatModal}
          openHistoryModal={this.openHistoryModal}
          closeHistoryModal={this.closeHistoryModal}
          isHistoryModalOpen={this.state.isHistoryModalOpen}
          idPatientToShow={this.state.idPatientToShow}
          user={this.props.loggedInUserQuery.loggedInUser}
        />

        {this.props.history.location.pathname !== "/" ? (
          <div className="container">
            <div className="columns  is-centered">
              <div className="column is-4">
                <h1 className="has-text-centered is-size-3">
                  {this.props.title}
                </h1>
              </div>
            </div>
            <div className="columns  is-centered">
              <div className="column is-12">{childrenWithProps}</div>
            </div>
          </div>
        ) : (
          <div className="container override-container">
            <div className="columns  is-centered">
              <div className="column is-12">{childrenWithProps}</div>
            </div>
          </div>
        )}

        {this.state.isOpenChatModal ? (
          <ChatModal
            toggleChatModal={this.toggleChatModal}
            patientId={this.state.patientId}
            user={this.props.loggedInUserQuery.loggedInUser}
          />
        ) : null}
        <ToastContainer
          style={{ top: "4em", height: "160px", zIndex: 100 }}
          draggablePercent={80}
        />
      </div>
    );
  }
}

const LOGGED_IN_USER_QUERY = gql`
  query LoggedInUserQuery {
    loggedInUser {
      id
      role
      email
      name
    }
  }
`;
/*const GET_IS_OPEN_MODAL = gql`
  query {
    patientDeleteModal @client {
      isOpenDeleteModal
      idPatientToDelete
    }
  }
`;*/
const GET_IS_HISTORY_MODAL_OPEN = gql`
  query {
    patientHistoryModal @client {
      isOpenHistoryModal
      idPatientToShow
    }
  }
`;
/*
const DELETE_PATIENT = gql`
  mutation deletePatientMutation($id: ID!) {
    deletePatient(id: $id) {
      id
    }
  }
`;

const UPDATE_DELETE_MODAL = gql`
  mutation updateDeleteModalOpen(
    $idPatientToDelete: String
    $isOpenDeleteModal: Boolean
  ) {
    updateDeleteModalOpen(
      idPatientToDelete: $idPatientToDelete
      isOpenDeleteModal: $isOpenDeleteModal
    ) @client
  }
`;*/

const UPDATE_HISTORY_MODAL = gql`
  mutation updateHistoryModal(
    $idPatientToShow: String
    $isOpenHistoryModal: Boolean
  ) {
    updateHistoryModal(
      idPatientToShow: $idPatientToShow
      isOpenHistoryModal: $isOpenHistoryModal
    ) @client
  }
`;
const NEW_MESSAGES = gql`
  query GetNewMessagesQuery($doctorId: ID!) {
    allMessages(
      orderBy: createdAt_ASC
      filter: { AND: [{ to_some: { id: $doctorId } }, { status: NEW }] }
    ) {
      id
      createdAt
      text
      patient {
        id
        nom
        prenom
        matricule
      }
      from {
        id
        name
      }
      to {
        id
        name
      }
      reply {
        id
        from {
          id
          name
        }
        patient {
          id
          nom
          prenom
        }
        text
        createdAt
      }
    }
  }
`;

export default compose(
  DragDropContext(HTML5Backend),
  graphql(LOGGED_IN_USER_QUERY, {
    name: "loggedInUserQuery",
    options: { fetchPolicy: "network-only" },
  }),
  graphql(NEW_MESSAGES, {
    name: "newMessagesQuery",
    options: ({ doctorId }) => ({ variables: { doctorId } }),
    skip: ({ doctorId }) => doctorId === null,
  }),
  /*  graphql(DELETE_PATIENT, {
    name: "deletePatient"
  }),
  graphql(UPDATE_DELETE_MODAL, {
    name: "updateDeleteModal"
  }),
  graphql(GET_IS_OPEN_MODAL, {
    name: "getIsModalOpen",
    options: { fetchPolicy: "cache-only" }
  }),*/
  graphql(UPDATE_HISTORY_MODAL, {
    name: "updateHistoryModal",
  }),
  graphql(GET_IS_HISTORY_MODAL_OPEN, {
    name: "getIsHistoryModalOpen",
    options: { fetchPolicy: "cache-only" },
  }),
  withApollo
)(Layout);



// WEBPACK FOOTER //
// ./src/components/utilities/Layout.js